<div class="w-100 record-interface" #recordInterface>
  <div class="row">
    <div class="col-12">
      @if (hasError) {
        <div class="mat-bg-warn">
          {{error}}
        </div>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <audio #player preload="metadata">
        Your browser does not support the audio tag.
      </audio>
      <div class="wrapper d-flex flex-row justify-content-between align-items-center md-3" [class.d-none]="!(isExtraSmall$ | async)">
        @if (!recording && !isPlaying) {
          <button mat-icon-button class="ms-3" (click)="play()" [disabled]="!hasAudio"><mat-icon>play_arrow</mat-icon></button>
        }
        @if (!recording && isPlaying) {
          <button mat-icon-button class="ms-3" (click)="pause()" [disabled]="!hasAudio"><mat-icon>pause</mat-icon></button>
        }
        @if (recording) {
          <span class="timestamp mx-3">
            {{duration | appMsToSeconds | appTimeDuration}}
          </span>
        }
        @if (!recording) {
          <span class="timestamp mx-3">
            {{playbackTime | appTimeDuration}}
          </span>
        }
        @if (recording) {
          <div class="waveform d-flex flex-row justify-content-between align-items-center flex-grow-1">
            @for (wave of waveform; track wave) {
              <div class="wave-item" style="height: {{wave}}%;"></div>
            }
          </div>
        }
        <input type="range" class="seeker w-100" #seeker max="100" value="0" [class.d-none]="recording" [class.disabled]="!hasAudio" [disabled]="!hasAudio" [(ngModel)]="playbackTime" (input)="onSeekerInput()" (change)="onSeekerChange()"/>
        @if (!recording) {
          <span class="timestamp mx-3">
            {{duration | appMsToSeconds | appTimeDuration}}
          </span>
        }
      </div>
      <div class="wrapper d-flex flex-row justify-content-between align-items-center" [class.d-none]="!(isExtraSmall$ | async)">
        @if (!recording) {
          <button mat-icon-button class="mat-bg-warn text-light ms-3" (click)="clearRecording()" [disabled]="!hasAudio"><mat-icon>delete</mat-icon></button>
        }
        @if (recording) {
          <button mat-icon-button class="ms-3" (click)="stopRecording()"><mat-icon>pause</mat-icon></button>
        }
        @if (!recording) {
          <button mat-icon-button class="ms-3" (click)="startRecording()"><mat-icon>mic</mat-icon></button>
        }
      </div>
      <div class="wrapper d-flex flex-row justify-content-between align-items-center " [class.d-none]="isExtraSmall$ | async">
        @if (!recording) {
          <button mat-icon-button class="mat-bg-warn text-light ms-3" (click)="clearRecording()" [disabled]="!hasAudio"><mat-icon>delete</mat-icon></button>
        }
        @if (!recording && !isPlaying) {
          <button mat-icon-button class="ms-3" (click)="play()" [disabled]="!hasAudio"><mat-icon>play_arrow</mat-icon></button>
        }
        @if (!recording && isPlaying) {
          <button mat-icon-button class="ms-3" (click)="pause()" [disabled]="!hasAudio"><mat-icon>pause</mat-icon></button>
        }
        @if (recording) {
          <span class="timestamp mx-3">
            {{duration | appMsToSeconds | appTimeDuration}}
          </span>
        }
        @if (!recording) {
          <span class="timestamp mx-3">
            {{playbackTime | appTimeDuration}}
          </span>
        }
        @if (recording) {
          <div class="waveform d-flex flex-row justify-content-between align-items-center flex-grow-1">
            @for (wave of waveform; track wave) {
              <div class="wave-item" style="height: {{wave}}%;"></div>
            }
          </div>
        }
        <mat-slider color="primary" [max]="duration/1000" class="w-100" [class.d-none]="recording" [disabled]="!hasAudio" [(ngModel)]="playbackTime" #ngSlider><input matSliderThumb (input)="onSeekerInput()" #ngSliderThumb="matSliderThumb" (change)="onSeekerChange()" />
          <input matSliderThumb>
        </mat-slider>
        @if (!recording) {
          <span class="timestamp mx-3">
            {{duration | appMsToSeconds | appTimeDuration}}
          </span>
        }
        @if (recording) {
          <button mat-icon-button class="ms-3" (click)="stopRecording()"><mat-icon>pause</mat-icon></button>
        }
        @if (!recording) {
          <button mat-icon-button class="ms-3" (click)="startRecording()"><mat-icon>mic</mat-icon></button>
        }
      </div>
    </div>
  </div>
</div>
